import React, { useState } from 'react'
import SearchResult from './features/search/SearchResult'
import Filter from './features/filter/Filter'
import './assets/App.css'
import SelectedFilter from './features/filter/SelectedFilter'
import TopParts from './features/TopParts'
import Currency from './features/currency/Currency'
import searchParams from './utils/constants/searchParams'
import CompareGo from "./features/compare/CompareGo";
import ModalInviteToReg from './features/modal/ModalInviteToReg'

function App() {
    const [filterHide, setFilterHide] = useState('')
    const [resultHeight, setResultHeight] = useState('')

    return (
        <div className="page-search">
            <div className="p-search__header">
                <h1>
                    Найдено по запросу «{searchParams.QUERY.toUpperCase()}
                    {searchParams.BRAND_TITLE ? ' (' + searchParams.BRAND_TITLE + ')' : ''}»
                </h1>
                    <ModalInviteToReg />
                <div className="header-buttons">
                    <div className="compare-go__wrapper">
                        <CompareGo />
                    </div>
                    <div className="currency__wrapper">
                        <Currency />
                    </div>
                </div>
                <Filter
                    filterHide={filterHide}
                    setFilterHide={setFilterHide}
                    setResultHeight={setResultHeight}
                />
                <TopParts />
                <SelectedFilter filterHide={filterHide} />
            </div>
            <div
                className={['p-search__result', filterHide].join(' ')}
                style={{ minHeight: resultHeight + 'px' }}
            >
                <SearchResult />
            </div>
        </div>
    )
}

export default App
